<!--
  - Copyright (c) 2019 Eva Novotná, Juraj Šimon
  -->

<template>
  <div>
    <div ref="header" id="what-i-do" class="main-title is-uppercase">
      {{ $t("what i do") }}
    </div>
    <div class="what-i-do-section">
      <div class="columns is-gapless is-multiline">
        <div class="column is-one-third run">
          <div class="tile-text" v-if="locale === 'en'">
            <div class="label-top is-uppercase">Running</div>
            <div class="label-bottom is-uppercase">Coach</div>
          </div>
          <div class="tile-text" v-if="locale === 'cs'">
            <div class="label-bottom is-uppercase">Trenér</div>
            <div class="label-top is-uppercase">Běhání</div>
          </div>
        </div>
        <div class="column is-one-third swim">
          <div class="tile-text" v-if="locale === 'en'">
            <div class="label-top is-uppercase">swimming</div>
            <div class="label-bottom is-uppercase">Coach</div>
          </div>
          <div class="tile-text" v-if="locale === 'cs'">
            <div class="label-bottom is-uppercase">Trenér</div>
            <div class="label-top is-uppercase">plavání</div>
          </div>
        </div>
        <div class="column is-one-third ski">
          <div class="tile-text" v-if="locale === 'en'">
            <div class="label-top is-uppercase">Skiing</div>
            <div class="label-bottom is-uppercase">Coach</div>
          </div>
          <div class="tile-text" v-if="locale === 'cs'">
            <div class="label-bottom is-uppercase">Trenér</div>
            <div class="label-top is-uppercase">Lyžování</div>
          </div>
        </div>
        <div class="column is-one-third climbing">
          <div class="tile-text" v-if="locale === 'en'">
            <div class="label-top is-uppercase">climbing</div>
            <div class="label-bottom is-uppercase">Coach</div>
          </div>
          <div class="tile-text" v-if="locale === 'cs'">
            <div class="label-bottom is-uppercase">Trenér</div>
            <div class="label-top is-uppercase">lezení</div>
          </div>
        </div>
        <div class="column is-one-third vpp">
          <div class="tile-text" v-if="locale === 'en'">
            <div class="label-top is-uppercase">Všestranná</div>
            <div class="label-bottom is-uppercase">pohybová<br />příprava</div>
          </div>
          <div class="tile-text" v-if="locale === 'cs'">
            <div class="label-bottom is-uppercase">Všestranná</div>
            <div class="label-top is-uppercase">pohybová<br />příprava</div>
          </div>
        </div>
        <div class="column is-one-third filler"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters({
      whatIDo: "home/whatIDo"
    }),
    locale() {
      return this.$root.$i18n.locale;
    }
  },
  methods: {
    ...mapActions({
      setWhatIDo: "home/setWhatIDo"
    }),
    handleScroll() {
      let dim = this.$refs.header.getBoundingClientRect();
      if (dim.y + this.$refs.header.offsetHeight - 100 > 0 && this.whatIDo) {
        this.setWhatIDo(false);
      }
      if (dim.y + this.$refs.header.offsetHeight - 100 < 0 && !this.whatIDo) {
        this.setWhatIDo(true);
      }
    }
  },
  mounted() {
    this.handleScroll();
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="scss" scoped>
@import "./what-i-do";
</style>
